import React from "react";
import ActualSales from '../components/actualSales'

const ActualSalesPage = () => {
    return (
        <>
            <ActualSales />
        </>
    );
};

export default ActualSalesPage;
